module.exports = __webpack_public_path__ + "img/Saloons_disabled.dc789383.svg";